import { lzPluralize } from "../../services/LzStrings";
import MediaModel from "../media";

/**
 * LzCrudModelField class
 */
export default class LzCrudModelField {

    static TYPE_STRING = 'string';
    static TYPE_NUMBER = 'number';
    static TYPE_BOOLEAN = 'boolean';
    static TYPE_REFERENCE = 'reference';
    static TYPE_MEDIA = 'media';

    static DEFAULT_VALUES_FOR_TYPES = {
        string: '',
        number: 0,
        boolean: false,
        reference: null,
        media: null,
    };

    constructor(model, key) {
        if (!model) {
            model = {};
        }

        this.size = model.size ? +model.size : 50;
        this.type = model.type ? model.type : LzCrudModelField.TYPE_STRING;
        this.translatable = !!model.translatable;
        this.required = typeof model.required === 'boolean' ? model.required : false;
        this.default = typeof model.default !== 'undefined' ? model.default : LzCrudModelField.DEFAULT_VALUES_FOR_TYPES[this.type];
        this.options = model.options ? model.options : null;

        // If field is a reference to another table then load reference related fields
        if (this.type === LzCrudModelField.TYPE_REFERENCE) {
            this.refTableName = model.refTableName ? model.refTableName : LzCrudModelField.getTableNameFromKey(key);
            this.refTableIdField = model.refTableIdField ? model.refTableIdField : 'id';
            this.refTableTitleField = model.refTableTitleField ? model.refTableTitleField : 'name';
            this.refAppendedDisplayField = model.refAppendedDisplayField ? model.refAppendedDisplayField : LzCrudModelField.getAppendedDisplayField(key, this.refTableTitleField);
            this.refFilterFieldKeys = model.refFilterFieldKeys ? model.refFilterFieldKeys : [];
        }

        // If field is media then load media related fields
        if (this.type === LzCrudModelField.TYPE_MEDIA) {
            this.mediaCategory = model.mediaCategory ? model.mediaCategory : '';                            // specified to shortlist the uploadable images and set in the resulting media object
            this.mediaFileType = model.mediaFileType ? model.mediaFileType : MediaModel.FILE_TYPE_IMAGE;    // specified to shortlist the uploadable images and set in the resulting media object
            this.mediaContentType = model.mediaContentType ? model.mediaContentType : '';                   // specified to shortlist the uploadable images, the uploaded one will be set in the resulting media object
            this.mediaIsPrivate = !!model.mediaIsPrivate;                                                   // specified to shortlist the uploadable images and set in the resulting media object
        }
    }

    static parseData(data) {
        const out = {};

        if (!data) {
            return out;
        }

        const keys = Object.keys(data);
        for (const key of keys) {
            out[key] = new LzCrudModelField(data[key], key);
        }

        return out;
    }

    static getTableNameFromKey(key) {
        if (!key) {
            return '';
        }

        return lzPluralize(key.substring(0, key.length - 3));
    }

    static getAppendedDisplayField(key, otherTableTitleField) {
        return key.substring(0, key.length - 2) + otherTableTitleField;
    }

}
